const state = {
    // `basic` ELTÁVOLÍTVA: `true`-ra volt inicializálva, egyetlen mutáció sem
    // írta át soha, és az egyetlen olvasója (App.vue) ebből sugározta szét a
    // BASICMODECHANGED-et - ami így mindig egyszerűsítettre kapcsolta a
    // felületet verziófrissítés után. A nézet tényleges forrása a dbmanager
    // `basic` configja és a mérkőzés adataiból jövő érték (l. Settings.vue).
    isMirrored: false,
    darkmode: true,
    isLoggedin: false,
    showMenu: false,
    tickInProgress: false,
    overlay: true, // Loading overlay
    hotkeys: true,
    hotkeysEnabled: true,
    activeDialog: null,
    GameFinishDialog: false,
    GameSyncDialog: false,
    gameOverDialog: false,
    syncDialog: false,
    openedDialog: false,
    goalkeeperDialog: false,
    strandGoalkeeperDialog: false,
    nomatchDialog: false,
    legacymode: false,
    showTimeLine: false,
    showPicker: false
};

const mutations = {
    SET_SHOW_PICKER(state, val) {
        state.showPicker = val;
    },
    SET_SHOWTIMELINE(state, val) {
        state.showTimeLine = val;
    },
    SET_NOMATCH_DIALOG(state, val) {
        state.nomatchDialog = val;
    },
    SET_LEGACYMODE(state, val) {
        state.legacymode = val;
    },
    SET_GOALKEEPER_DIALOG(state, val) {
        state.goalkeeperDialog = val;
    },
    SET_STRAND_GOALKEEPER_DIALOG(state, val) {
        state.strandGoalkeeperDialog = val;
    },
    SET_GAMEOVERDIALOG(state, val) {
        state.gameOverDialog = val;
    },
    SET_OPENEDDIALOG(state, val) {
        state.openedDialog = val;
    },
    SET_DARKMODE(state, val) {
        state.darkmode = val;
    },
    SET_GAMESYNCDIALOG(state, val) {
      state.GameSyncDialog = val;
    },
    SET_SYNCDIALOG(state, val) {
        state.syncDialog = val;
    },
    SET_GAMEFINISHDIALOG(state, val) {
      state.GameFinishDialog = val;
    },
    SET_LOGIN_STATUS(state, val) {
        state.isLoggedin = val;
    },
    SET_OVERLAY(state, val) {
        state.overlay = val;
    },
    SET_HOTKEYS(state, val) {
        state.hotkeys = val;
    },
    TOGGLE_MENU(state) {
        state.showMenu = !state.showMenu;
    },
    SET_SHOW_MENU(state, val)
    {
        state.showMenu = val;
    },
    SET_ISMIRRORED(state, val) {
        state.isMirrored = val;
    },
    SET_TICK_IN_PROGRESS(state, val) {
        state.tickInProgress = val;
    }
};

export default {
    namespaced: true,
    state,
    mutations
};
